export { ShoppingCart as default } from './ShoppingCart';
